/** Hooks das telas de cargas e acerto (Fase 6). */
import type { Load } from "@cafegestor/shared";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export const LOAD_KEY = ["cargas"];

/** Cargas abertas visíveis ao usuário (o vendedor restrito só vê a dele). */
export function useOpenLoads(enabled = true) {
  return useQuery({
    queryKey: [...LOAD_KEY, "abertas"],
    queryFn: () => apiFetch<Load[]>("/cargas/abertas"),
    staleTime: 15_000,
    enabled,
  });
}
